import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTE_TT_TypeOfWork = createAsyncThunk(
  "dropdowns/GetAllTE_TT_TypeOfWork",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTE_TT_TypeOfWork"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownTE_TT_TypeOfWork = createSlice({
  name: "DropDownTargetedGroupAge",
  initialState: {
    DropDownTE_TT_TypeOfWork: [],
    loadingDropDownTE_TT_TypeOfWork: false,
    errorDropDownTE_TT_TypeOfWork: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTE_TT_TypeOfWork.pending, (state, action) => {
        state.loadingDropDownTE_TT_TypeOfWork = true;
        state.DropDownTE_TT_TypeOfWork = action.payload;
        state.errorDropDownTE_TT_TypeOfWork = null;
      })
      .addCase(GetAllTE_TT_TypeOfWork.fulfilled, (state, action) => {
        state.loadingDropDownTE_TT_TypeOfWork = false;
        state.DropDownTE_TT_TypeOfWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTE_TT_TypeOfWork.rejected, (state, action) => {
        state.loadingDropDownTE_TT_TypeOfWork = false;
        state.errorDropDownTE_TT_TypeOfWork = action.payload;
      });
  },
});

export default DropDownTE_TT_TypeOfWork.reducer;
